import axios from "axios";

// 🔹 Base URL
const API = axios.create({
  baseURL: "http://72.62.193.115:5001/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// =====================================================
// 🔹 Simple Default Payload (Reusable)
// =====================================================
const defaultPayload = {
  userId: "1",
  userName: "Test User",
  userPhone: "9999999999",
  botId: "1",
};

// =====================================================
// 🔹 Common API Methods
// =====================================================

export const get = async (url) => {
  try {
    const res = await API.get(url);
    return res.data;
  } catch (err) {
    handleError(err);
  }
};

export const post = async (url, data) => {
  try {
    const res = await API.post(url, data);
    return res.data;
  } catch (err) {
    handleError(err);
  }
};

export const put = async (url, data) => {
  try {
    const res = await API.put(url, data);
    return res.data;
  } catch (err) {
    handleError(err);
  }
};

export const del = async (url) => {
  try {
    const res = await API.delete(url);
    return res.data;
  } catch (err) {
    handleError(err);
  }
};

// =====================================================
// 🔹 Error Handler
// =====================================================
const handleError = (err) => {
  const message =
    err?.response?.data?.message || err.message || "API Error";
  console.error("❌", message);
  throw new Error(message);
};

export const getCustomerFromStorage = () => {
  const session = localStorage.getItem("session");

  try {
    return JSON.parse(session);
  } catch (e) {
    return null;
  }
};

// =====================================================
// 🔹 Your APIs
// =====================================================

// ✅ Fetch Slider API (uses simple payload)
export const fetchSliders = async (customPayload = {}) => {
  const payload = { ...defaultPayload, ...customPayload };
  return await get("/FetchSlider", payload);
};
// ✅ Fetch Category API (uses simple payload)
export const fetchCategory = async (customPayload = {}) => {
  const payload = { ...defaultPayload, ...customPayload };
  return await get("/FetchCategory", payload);
};

// ✅ Fetch Category API (uses simple payload)
export const fetchLetestDesign = async (customPayload = {}) => {
  const payload = { ...defaultPayload, ...customPayload };
  return await get("/FetchLetestDesign", payload);
};

// ✅ Fetch Category API (uses simple payload)
export const fetchShopByType = async (customPayload = {}) => {
  const payload = { ...defaultPayload, ...customPayload };
  return await get("/FetchShopByType", payload);
};

//FetchTraditionalJwalelry
export const fetchTraditionalJwalelryAndAllProduct = async (customPayload = {}) => {
  const payload = { ...defaultPayload, ...customPayload };
  return await get("/FetchTraditionalJwalelryAndAllProduct", payload);
};


//FetchTraditionalJwalelry
export const fetchAllProduct = async (customPayload = {}) => {
  const payload = { ...defaultPayload, ...customPayload };
  return await get("/FetchAllProduct", payload);
};

//FetchTraditionalJwalelry
export const fetchProductByReels = async (customPayload = {}) => {
  const payload = { ...defaultPayload, ...customPayload };
  return await get("/FetchProductByReels", payload);
};

// =====================================================
// 🔹 Customer Login API
// =====================================================
export const customerLogin = async (data) => {
  try {
    const res = await post("/customerLogin", data);
    return res;
  } catch (err) {
    handleError(err);
  }
};

export const verifyCustomerOtp = async (data) => {
  try {
    const res = await post("/verifyOtp", data);
    return res;
  } catch (err) {
    handleError(err);
  }
};

export const fetchState = async (countryId) => {

  const res = await get(`/fetchStates/${countryId}`);

  return res.data;
};

export const fetchCity = async (stateId) => {
  const res = await get(`/fetchCities/${stateId}`);
  return res.data;
};

// ✅ Order Place API

export const order_place = async (data) => {

  return await post("/placeOrder", data);

};
export const fetchRecommendedProduct = async (data) => {
  return await post("/fetchRecommendedProduct", data);

};

export const registerCustomer = (data) => {
  return post("/register-customer", data);
};

export const fetchCustomerDetail = (customer_id) => {
  return get(`/fetch-customer/${customer_id}`);
};


export const fetchOrders = async (data) => {
  return await post("/fetch-orders", data);
};

export const fetchCustomerAddress = async (data) => {
  return await post("/fetch-address", data);
};

export const forgotPassword = async (data) => {
  const response = await post(
    "/forgot-password",
    data
  );

  return response.data;
};

export const resetPassword = async (data) => {
  const response = await post(
    "/reset-password",
    data
  );

  return response.data;
};
